import { jsx as _jsx } from "react/jsx-runtime";
import { Menu } from "../Menu";
export const MenuItem = (props) => (_jsx(Menu, { items: [Object.assign(Object.assign({}, props), { key: "0" })] }));
